import { DriversList } from "components/drivers/list";
import { hiddenUserData } from "helpers/hiddenData";
import { paths } from "helpers/paths";
import { BooleanColumnFilter, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { isOnlyInRole } from "helpers/roles";
import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { getOrganizationNames, setEmptyDriverBidPointDates } from "sources/admin";

class AdminDriversList extends DriversList {
    get tableColumns() {
        return [
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            { Header: "ID пользователя", accessor: "userId", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Имя",
                accessor: "fullName",
                id: "fullName",
                filterable: true,
                sortable: false,
                Cell: ({ value, row }) => {
                    const { id, lastSignIn, isOnline } = row.original;
                    return (
                        <span>
                            {this.onlineInfo(isOnline, lastSignIn, id)}
                            &nbsp;
                            {value}
                        </span>
                    );
                },
            },
            {
                Header: "Организация",
                accessor: "organizationName",
                id: "organizationId",
                sortable: true,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getOrganizationNames,
                            inputProps: { name: "organizationId" },
                            propName: "name",
                        }}
                    />
                ),
            },
            {
                Header: "Номер телефона",
                accessor: "phoneNumber",
                width: 150,
                sortable: true,
                filterable: true,
                Cell: ({ value }) =>
                    hiddenUserData(value, { type: "phone" }, isOnlyInRole(this.props.roles, "isTechSupport")),
            },
            { Header: "Пароль", accessor: "password", width: 150, sortable: false, filterable: false },
            {
                Header: "Удален",
                accessor: "isDeleted",
                width: 150,
                sortable: true,
                filterable: true,
                filterType: "boolean",
                Filter: (props) => {
                    const defaultValue = { id: "isDeleted", value: "false", filterType: "boolean" };
                    const options = [
                        { label: "Показать все", value: "all" },
                        { label: "Удаленные", value: "true" },
                        { label: "Не удаленные", value: "false" },
                    ];
                    return <BooleanColumnFilter {...props} options={options} defaultValue={defaultValue} />;
                },
                Cell: ({ value }) => <div className="text-center">{value ? "Да" : "Нет"}</div>,
                CSVExport: ({ value }) => (value ? "Да" : "Нет"),
            },
            {
                Header: "Действия",
                id: "actions",
                sortable: false,
                filterable: false,
                notExportable: true,
                width: 250,
                Cell: ({ row: { original } }) => this.renderDriverActions(original),
            },
        ];
    }

    renderCreateButton = () => (
        <Link to={paths.adminDriverDeviceStatistics} className="inline-btn inline-btn--without-icon">
            Информация об устройствах
        </Link>
    );

    renderDriverActions = (driver) => {
        const { isDeleted } = driver;
        const { roles } = this.props;
        const hasAccess = roles.isRoot || roles.isIntegrationManager;

        // Don't show button for deleted drivers or users without access
        if (isDeleted || !hasAccess) {
            return null;
        }

        return (
            <span
                className="inline-btn inline-btn--without-icon"
                onClick={this.markDriverBidsVisited.bind(this, driver)}
            >
                Отметить заявки посещенными
            </span>
        );
    };

    markDriverBidsVisited = (driver) => {
        const { id, fullName, organizationId } = driver;
        const { modal, mergeParams } = this.props;

        return modal({
            name: "confirm",
            title: "Отметить заявки посещенными",
            text: `Вы уверены, что хотите отметить все заявки водителя "${fullName}" как посещенные?`,
            buttons: {
                confirm: "Отметить",
            },
            action: () => {
                return setEmptyDriverBidPointDates({
                    organizationId: organizationId,
                    driverIds: [id],
                }).then((response) => {
                    mergeParams({});
                    return response;
                });
            },
            onSuccessAction: (response) => {
                if (response) {
                    this.showResultModal(response, fullName);
                }
            },
        });
    };

    showResultModal = (response, driverName) => {
        const { modal } = this.props;

        return modal({
            name: "infoModal",
            title: "Результат",
            body: (
                <div>
                    <p>
                        Для водителя <strong>"{driverName}"</strong> были обработаны заявки
                    </p>
                    <p className="text-center mb-0">
                        <strong className="text-success">{response.message}</strong>
                    </p>
                </div>
            ),
        });
    };
}

export default tableContainer(AdminDriversList, "admindrivers");
